import { defineMessages } from 'react-intl';

export default defineMessages({
    tooltipDummy: {
        id: 'custom.products.WCM.tooltip.Dummy',
        defaultMessage: 'Dummy'
    }
    
})